import { createQueryStringSelector } from "selectors/queryString"
import { get } from "lodash"
import { createSelector } from "reselect"
import { VIEW_TYPES } from "helpers/base"

const EMPTY_ARRAY = []

export const getViewType = (_, props) => props.viewType
export const getBase = (_, props) => props.base
export const getOnly = createQueryStringSelector("only")
export const getDisabled = createQueryStringSelector("disabled", EMPTY_ARRAY)
export const getFocusedChartLine = state => get(state, "modules.analyzeCompositeRisk.focusedChartLine")
export const getSegment = (_, props) => props.segment
export const getIsActive = createSelector(
  [getViewType],
  (viewType) => viewType === VIEW_TYPES.ACTIVE,
)
